// src/utils/calculateDeliveryDate.ts

export function calcularDataDeEntrega(workdays: number = 20): string {
    const resultDate = new Date();
    let daysRemaining = workdays;

    while (daysRemaining > 0) {
        resultDate.setDate(resultDate.getDate() + 1);
        // Skip weekends
        if (resultDate.getDay() !== 0 && resultDate.getDay() !== 6) {
            daysRemaining--;
        }
    }

    const day = resultDate.getDate();
    const month = resultDate.toLocaleString('pt-BR', { month: 'long' });

    return `${day} de ${month}`;
}
